/* eslint-disable */
/* THIS FILE HAS BEEN GENERATED DO NOT EDIT IT DIRECTLY */
import * as Types from '../../../../../graphql/__generated__/types';

import { gql } from '@apollo/client';
export type DefaultConfigurationCell_ClaimCodeFragment = { __typename: 'MultiClaimCodeDocument', id: string };

export type DefaultConfigurationCell_CustomerFragment = { __typename: 'Customer', id: string, handle: string, supportedPlatforms: Array<string>, configurations: Array<{ __typename: 'ConfigurationModel', id: string, name: string, state: Types.ConfigurationStatus, platform: string }>, multiClaimDefaultConfigurations?: Array<{ __typename: 'DefaultConfiguration', id: string, type: Types.DefaultConfigurationType, multiClaimId?: string | null, defaultConfigurations: Array<{ __typename: 'DefaultConfigurationMap', platform: string, configurationId: string }> }> | null };

export const DefaultConfigurationCell_ClaimCodeFragmentDoc = gql`
    fragment DefaultConfigurationCell_claimCode on MultiClaimCodeDocument {
  id
}
    `;
export const DefaultConfigurationCell_CustomerFragmentDoc = gql`
    fragment DefaultConfigurationCell_customer on Customer {
  id
  handle
  configurations {
    id
    name
    state
    platform
  }
  supportedPlatforms
  multiClaimDefaultConfigurations {
    id
    type
    multiClaimId
    defaultConfigurations {
      platform
      configurationId
    }
  }
}
    `;